"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deprecate = void 0;

/**
 * @namespace skybase-core.utils.logger
 */

/**
 * @description
 * deprecation message helper function
 *
 * @name skybase-core.utils.logger#deprecate
 *
 * @Function
 * @param  {String} message message should include what should be used instead of deprecated feature.
 */
var deprecate = function deprecate(message) {
  console.warn('[DEPRECATED]', message); // eslint-disable-line no-console
};

exports.deprecate = deprecate;
//# sourceMappingURL=logger.js.map